import React from "react";
import { useParams } from "react-router-dom";
import './style.css';

export default function MmcPaymentPage() {
  const { paymentRequestId } = useParams();

  const url = `https://sph-dev2.uat.europcar.com/?paymentRequestId=${paymentRequestId}`;

  window.addEventListener('message', (event) => {
    const { name, source, status,  messageTranslationKey, } = event.data;
    console.log('Message: ' + JSON.stringify(event.data));

    if (source === 'PSH') {
      if (name === 'PAYMENT_STATUS') {
        if (status === 'SUCCESS') {
          window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://payment_redirect?result=success`;
        } else {
          window.location.href = `${process.env.REACT_APP_MOBILEAPP_ID}://payment_redirect?result=error&errorCode=${messageTranslationKey}&errorMessage=${messageTranslationKey}`;
        }

      }
    }
  });

  return (
    <iframe
      id="iframe"
      src={url}
      className="mmc-iframe"
      >

    </iframe>
  )
}
